import { render } from "./gTripleWattMinModal.vue?vue&type=template&id=3a222f5b&ts=true"
import script from "./gTripleWattMinModal.vue?vue&type=script&lang=ts"
export * from "./gTripleWattMinModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__